module.exports = __webpack_public_path__ + "static/joe-2fd8a3ebdfb29e9effbd1fa753ef8aad.png";